import router from "@/router";

const routeNameToChangeColorRelativeToProject = [
    'home',
    'projectManagements',
    'project-information',
    'projectPlanification',
    'subcontracting',
    'provisionalfee',
    'provisional-advancement',
] // https://dev.azure.com/RichezAssocies/Indicateur/_workitems/edit/1246

export default function routeIsValidForProjectSelector() {
    return !!router.currentRoute.name
        && routeNameToChangeColorRelativeToProject.includes(router.currentRoute.name)
}